// extracted by mini-css-extract-plugin
module.exports = {"avatar":"user-link_avatar__5UQ2l"};